import { Seo, breadcrumbJsonLd } from "@/lib/Seo";
import { PageHeader } from "@/components/PageHeader";
import { Phone, ArrowRight, ShieldCheck } from "lucide-react";
import { PHONE, PHONE_TEL } from "@/data/content";
import { btnPrimary } from "@/lib/ui";

const BREADCRUMB = [
  { name: "Home", path: "/" },
  { name: "Offerte aanvragen", path: "/offerte" },
];

const QUOTE_URL = "https://offerte.beveiligalles.nl/";

export default function QuotePage() {
  return (
    <>
      <Seo
        title="Offerte thermische camera recyclingbedrijf aanvragen"
        description="Vraag een gratis locatieanalyse en offerte aan voor thermische branddetectie met Hikvision camera's. Landelijke levering, installatie en service."
        jsonLd={[breadcrumbJsonLd(BREADCRUMB)]}
      />
      <PageHeader
        overline="Gratis locatieanalyse"
        title="Vraag een offerte aan"
        intro="Start uw aanvraag via ons offerteformulier. Beantwoord enkele korte vragen over uw locatie — een specialist beoordeelt de informatie en neemt contact met u op."
        breadcrumb={BREADCRUMB}
      />
      <section className="py-16 md:py-24">
        <div className="mx-auto max-w-3xl px-4 text-center sm:px-6 lg:px-10">
          <div className="rounded-3xl border border-white/10 bg-[#10232F]/50 p-10 backdrop-blur-xl sm:p-14" data-testid="quote-cta-card">
            <p className="text-base leading-relaxed text-[#CBD3D9]">
              U wordt doorgestuurd naar ons beveiligde offerteportaal. Daar vragen we naar uw
              bedrijfsgegevens, de te bewaken gebieden en eventuele documenten of foto's, zodat een
              specialist uw locatie goed kan beoordelen.
            </p>
            <a
              href={QUOTE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className={`${btnPrimary} mt-8 justify-center`}
              data-testid="quote-external-cta"
            >
              Vraag mijn locatieanalyse aan <ArrowRight size={16} />
            </a>
            <div className="mt-8 flex flex-wrap justify-center gap-x-6 gap-y-2 border-t border-white/10 pt-6">
              {["Vertrouwelijke behandeling", "Geen verplichtingen", "Projectgericht advies", "Landelijke installatie en service"].map((t) => (
                <span key={t} className="flex items-center gap-1.5 text-xs text-[#CBD3D9]/70">
                  <ShieldCheck size={13} className="text-[#2B9FD7]" /> {t}
                </span>
              ))}
            </div>
          </div>
          <p className="mt-8 text-center text-sm text-[#CBD3D9]/70">
            Liever direct contact?{" "}
            <a href={PHONE_TEL} className="inline-flex items-center gap-1.5 font-semibold text-[#62C3F0] transition-colors hover:text-[#F5F7F9]">
              <Phone size={14} /> Bel {PHONE}
            </a>
          </p>
        </div>
      </section>
    </>
  );
}
